var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTestBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.043,
    height: 26.511,
    viewBox: "0 0 26.043 26.511",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Test",
    transform: "translate(-82.838 -7.567)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24244",
    "data-name": "Path 24244",
    d: "M225.443,26.575a.417.417,0,0,1-.294-.121l-2.509-2.493a.418.418,0,0,1-.106-.418,40.129,40.129,0,0,1,2.338-5.933,24.756,24.756,0,0,1,3.7-6.045h0c3.549-3.738,9.25-3.9,12.331-3.665a.418.418,0,0,1,.385.387c.215,3.081.024,8.771-3.671,12.269a23.938,23.938,0,0,1-6.088,3.681,40.677,40.677,0,0,1-5.969,2.322.413.413,0,0,1-.12.018Zm-2.036-3.03,2.153,2.14a39.917,39.917,0,0,0,5.61-2.2,22.963,22.963,0,0,0,5.874-3.534c3.309-3.132,3.6-8.242,3.435-11.242-3-.182-8.118.085-11.3,3.432a24.135,24.135,0,0,0-3.559,5.837,39.343,39.343,0,0,0-2.216,5.569Z",
    transform: "translate(-132.729 0)",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24245",
    "data-name": "Path 24245",
    d: "M395.315,138.135a2.331,2.331,0,0,1-1.647-.677,2.31,2.31,0,0,1,0-3.281,2.343,2.343,0,0,1,3.295,0,2.31,2.31,0,0,1,0,3.281,2.329,2.329,0,0,1-1.648.677Zm0-3.8a1.5,1.5,0,0,0-1.058.435,1.474,1.474,0,0,0,0,2.095,1.5,1.5,0,0,0,2.116,0h0a1.474,1.474,0,0,0,0-2.095,1.5,1.5,0,0,0-1.058-.435Z",
    transform: "translate(-295.055 -119.669)",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24246",
    "data-name": "Path 24246",
    d: "M158.43,127.721H158.4l-4.187-.334a.418.418,0,0,1-.366-.541c.14-.447,1.551-4.44,8.025-7.048a.418.418,0,1,1,.287.786c-5.015,2.027-6.778,4.85-7.316,6.014l3.623.289a.418.418,0,0,1-.033.835Z",
    transform: "translate(-67.32 -106.591)",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24247",
    "data-name": "Path 24247",
    d: "M338.481,298.209a.418.418,0,0,1-.417-.384l-.336-4.158a.418.418,0,1,1,.833-.067l.291,3.6c1.167-.531,4.008-2.276,6.05-7.248a.417.417,0,0,1,.171-.237.45.45,0,0,1,.049-.028.418.418,0,0,1,.574.532c-2.625,6.433-6.643,7.835-7.092,7.974a.422.422,0,0,1-.123.018Z",
    transform: "translate(-242.437 -268.351)",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24248",
    "data-name": "Path 24248",
    d: "M455.227,30.633a.415.415,0,0,1-.294-.121l-6.478-6.436a.418.418,0,1,1,.589-.593l6.478,6.436a.418.418,0,0,1-.294.714Z",
    transform: "translate(-347.758 -14.791)",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24249",
    "data-name": "Path 24249",
    d: "M88.808,412.116a.418.418,0,0,1-.3-.708l5.723-5.926a.418.418,0,0,1,.6.581l-5.723,5.926a.418.418,0,0,1-.3.127Z",
    transform: "translate(-5.01 -378.537)",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24250",
    "data-name": "Path 24250",
    d: "M173.125,452.24a.418.418,0,0,1-.312-.7l3.709-4.175a.418.418,0,1,1,.625.555l-3.709,4.175a.417.417,0,0,1-.313.141Z",
    transform: "translate(-85.3 -418.412)",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24251",
    "data-name": "Path 24251",
    d: "M83.546,368.48a.418.418,0,0,1-.312-.7l3.709-4.175a.418.418,0,0,1,.625.555l-3.709,4.175a.417.417,0,0,1-.313.141Z",
    transform: "translate(0 -338.653)",
    stroke: "#000",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestBlack);
export default __webpack_public_path__ + "static/media/Test_black.cc13d9fbe1ce63ebf385220bb3ef2c30.svg";
export { ForwardRef as ReactComponent };